var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDirectionsManeuverFerry = function SvgDirectionsManeuverFerry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M21.567 16.657v-5.784a3.283 3.283 0 0 0-3.284-3.284h-6.566a3.283 3.283 0 0 0-3.284 3.284v5.784"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M26.492 18.627 15.61 14.273a1.64 1.64 0 0 0-1.22 0L3.508 18.627m2.034-.814 1.74 5.21M15 22.365v-8.209m9.458 3.657-1.82 5.447"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M23.37 21.072 15 17.724l-8.37 3.348M2.687 27.29a6.03 6.03 0 0 0 4.925-1.642 4.977 4.977 0 0 0 7.388 0 4.977 4.977 0 0 0 7.388 0 6.03 6.03 0 0 0 4.925 1.642M11.717 10.873h6.566m-1.641-7.388a.82.82 0 0 0-.821-.82h-1.642a.82.82 0 0 0-.82.82V7.59h3.283z"
  }))));
};
export default SvgDirectionsManeuverFerry;